package com.tregz.polyglot.di

import kotlinx.browser.window

class LanguageJS : Language {
    override val code: String
        get() = tag.split('-', '_').first().ifBlank { "en" }

    // window is undefined under Node; fall back to English instead of throwing.
    override val tag: String
        get() = try {
            window.navigator.language.ifBlank { "en" }
        } catch (_: Throwable) {
            "en"
        }
}

actual val language: Language = LanguageJS()
